import { render, staticRenderFns } from "./PermissionsDashboard.vue?vue&type=template&id=0998231a&scoped=true&"
import script from "./PermissionsDashboard.vue?vue&type=script&lang=js&"
export * from "./PermissionsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsDashboard.vue?vue&type=style&index=0&id=0998231a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998231a",
  null
  
)

export default component.exports